<template>
  <div>
    <div v-if="recommendedSkillIds.length > 0">
      <h3 class="mb-1">{{ $t('1') }}</h3>
      <div v-if="isShowingProgress" :style="`min-height:${progressContainerMinHeight}px`">
        <v-progress-linear indeterminate color="primary"></v-progress-linear>
      </div>
      <div v-else id="recommendedSkillsListContainer">
        <span v-for="(skillId, index) in recommendedSkillIds.slice(0, maxRecommendationNb)" :key="index">
          <v-chip v-if="beingAddedSkillIds.includes(skillId)" small class="mt-1 mr-2" color="secondary">
            <v-icon small class="mr-1 white--text">mdi-check</v-icon>
            <span class="white--text">{{ getSkillById(skillId).name }}</span>
          </v-chip>
          <v-chip v-else small @click="addSkill(skillId)" class="mt-1 mr-2">
            <v-icon small left>mdi-plus</v-icon>
            <span>{{ getSkillById(skillId).name }}</span>
          </v-chip>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const allSkills = require('@/assets/app/data/allSkills.json')

export default {
  props: {
    technicalSkills: Array
  },
  data: () => ({
    recommendedSkillIds: [],
    maxRecommendationNb: 20,
    isShowingProgress: false,
    lastSkillIdsListSent: [],
    beingAddedSkillIds: [],
    progressContainerMinHeight: 0
  }),
  mounted() {
    this.updateRecommendations()
  },
  computed: {
    sortedSkillIds() {
      return this.technicalSkills.map(skill => skill.id).sort((a,b) => a < b ? -1 : 1)
    }
  },
  methods: {
    getSkillById(skillId) {
      // No custom skills here.
      return allSkills.find(skill => skill.id === skillId)
    },
    async addSkill(skillId) {
      this.beingAddedSkillIds.push(skillId)
      this.$emit('addRecommendedSkill', skillId)
    },
    async updateRecommendations() {
      this.lastSkillIdsListSent = JSON.parse(JSON.stringify(this.sortedSkillIds))

      const skillPredictions = await this.callPythonGetSkillRecommendations(this.sortedSkillIds)
      const recommendedSkillIds = skillPredictions
        .map(skillPrediction => skillPrediction.skill_id)
        .filter(skillId => !!skillId)
        .filter(skillId => !this.sortedSkillIds.includes(skillId))

      // The following is runned about 5 secondes later, so this.lastSkillIdsListSent may have changed if sortedSkillIds changed in the meantime.
      // Update displayed values only if this lastSkillIdsListSent is the last one being added
      if (JSON.stringify(this.lastSkillIdsListSent) === JSON.stringify(this.sortedSkillIds)) {
        const recommendedSkillsListContainer = document.querySelector('#recommendedSkillsListContainer')
        if (recommendedSkillsListContainer) this.progressContainerMinHeight = recommendedSkillsListContainer.offsetHeight
        this.isShowingProgress = true
        this.recommendedSkillIds = recommendedSkillIds
        setTimeout(() => {
          // Use timeout just to show user that it is refreshed, and avoid miss-clicks
          this.lastSkillIdsListSent = []
          this.beingAddedSkillIds = []
          this.isShowingProgress = false
        }, 300)
      }
    },
    callPythonGetSkillRecommendations(skillIds) {
      const url = `https://europe-west1-${process.env.VUE_APP_projectId}.cloudfunctions.net/python_get_skill_recommendations`
      return axios({
        method : 'POST',
        url,
        data: {
          skillIds
        }
      }).then(res => res.data)
    },
  },
  watch: {
    sortedSkillIds: {
      handler() {
        this.updateRecommendations()
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "1": "Suggestions"
  },
  "en": {
    "1": "Suggestions"
  }
}
</i18n>